import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export const Layout = ({
  children
}: LayoutProps) => {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-129">
      <Header data-id="element-130" />
      <main className="flex-grow" data-id="element-131">{children}</main>
      <Footer data-id="element-132" />
    </div>;
};